import ReactTooltip from "react-tooltip";
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useHistory, useLocation } from "react-router";
import { NavLink, withRouter } from "react-router-dom";
import LanguageContext from "./helper/LanguageContext";
import { connect, useDispatch, useSelector } from "react-redux";
import { BASE_URL, TOGGLE_DRAWER, getAvatarInitials } from "./helper/constants";
import { useDrop } from "react-dnd";
import { $crud } from "./helper/CrudFactory";
import { persistPinnedRooms } from "./utils/pinnedRooms";
import { PINNED_ROOMS_MAX, ROOM_DND_TYPE, findRoomInLists, resolvePinnedRoom, roomUnreadCount } from "./pages/Project/roomDnd";
import { Badge } from "react-bootstrap";
import MaterialIcon from './components/MaterialIcon';
import ProductTeaserModal from "./components/ProductTeaserModal";
import { saveWorkspacePreferences } from "./components/KjuupIoSetupModal";
import kjuupIconSrc from "./Icons/KjuupIcon.svg";
import PackageTile from "./components/PackageTile";
import { shouldShowDailyBriefingCounters } from "./utils/dailyBriefingCounters";
import { resolveCockpitPersona, chatsHidden, emailClientHidden, teamsClientHidden } from "./utils/cockpitPersona";
import { isTeamsChat } from "./utils/teams/teamsChats";
import { isProductSubscribed, resolveProductTarget, sidebarPackageOptions } from "./config/products";
import { openKjuupIoSubscription } from "./pages/Cockpit/cockpitNavigation";
import { recommendKjuup } from "./utils/recommendKjuup";
import { confirmAndLogout } from "./utils/logoutUser";
import "./styles/sidenavProducts.css";

import { ALL_BADGE_COUNT, GROUPS, NEWS_BADGE_COUNT, OPEN_CHATS, OPEN_PROJECTS, RIGHT_TOP, SET_IN_ACTIVITY, SET_OPEN_SIDE_BAR, SHOW_LIST_ONGOING, UPDATE_PROJECT_ACTION_FIRE, TOGGLE_CHAT, TOGGLE_PROJECT, TOGGLE_LATEST_MSG, TOGGLE_TODO_VIEW, SET_CHAT_FULLSCREEN, SET_TAB, SET_ACTIVE_PINNED_ROOM_ID } from "./store";
import { navigateToInternalArticle, parseScrollToArticleId } from "./utils/navigateToInternalArticle";
import featureFlags from "./featureFlags";
import { badgeChatsOf, countUnreadChats } from "./pages/Feeds/chatListModel";
import "./SideNav.css";

const ICON_PROPS = { size: 24, color: "#737373", fill: 0, weight: 300, grade: 0 };
// Kjuup logo with text (same asset as the login screen). Its icon part is cropped
// away in CSS so the sidebar icon is always the single `.sidenav-brand-mark` element.
const KJUUP_WORDMARK_SRC = process.env.PUBLIC_URL + "/assets/img/KJUUP-Schrift-Icon.png";

const SideNave = (props) => {
  const user = useSelector((state) => state.user);
  const profile = useSelector((state) => state.profile);
  const { unSeenAllCount, activityMessages } = useSelector((state) => state);
  const { drawerOpen } = useSelector((state) => state);
  const { pathname } = useLocation();
  const [openSidebar, setOpenSideBar] = useState("cockpit");
  const history = useHistory();
  const dispatch = useDispatch()
  const [isVisible, setIsVisible] = useState(false);
  const runningCalls = useSelector(e => e.runningCalls)
  const activeSideBar = useSelector(e => e.activeSideBar)
  const isDeskTopResolution = useSelector(e => e.isDeskTopResolution)
  const internalProjectsAll = useSelector(e => e.internalProjectsAll)
  const pinnedRooms = useSelector(e => e.pinnedRooms) || []
  const activePinnedRoomId = useSelector(e => e.activePinnedRoomId)
  const reduxProjects = useSelector(e => e.projects)
  const pinnedRoomsRef = useRef(pinnedRooms)
  pinnedRoomsRef.current = pinnedRooms
  const unseenDailyBriefingCount = useSelector(e => e.unseenDailyBriefingCount)
  const subscriptionState = useSelector(e => e.subscription)
  const showDailyBriefingCounters = shouldShowDailyBriefingCounters(user, profile, subscriptionState)
  const [teaserProduct, setTeaserProduct] = useState(null);

  // Persona drives the product label + which nested / add-on entries show.
  const personaInfo = useMemo(
    () => resolveCockpitPersona(profile, subscriptionState, user),
    [profile, subscriptionState, user]
  );
  const hideChats = chatsHidden(personaInfo);
  const hideEmailClient = emailClientHidden(personaInfo);
  const hideTeams = teamsClientHidden(personaInfo);
  const cockpitEnabled = !!featureFlags.enableCockpit;
  const packageOptions = useMemo(() => sidebarPackageOptions(personaInfo), [personaInfo]);

  const briefingFromStore = Number(unseenDailyBriefingCount);
  const briefingFromPayload = Number(unSeenAllCount?.unseenDailyBriefingCount);
  const briefingFromTabs =
    (Number(unSeenAllCount?.unseenExternalDailyBriefingCount) || 0) +
    (Number(unSeenAllCount?.unseenInternalDailyBriefingCount) || 0);
  const dailyBriefingBadge = showDailyBriefingCounters
    ? Math.max(
        0,
        briefingFromStore,
        Number.isFinite(briefingFromPayload) ? briefingFromPayload : 0,
        briefingFromTabs
      )
    : 0;
  // The Messages badge counts like the list's Unread chip: chats with unread
  // messages (the loaded rows by their own counts, plus the /badge/count `chat`
  // entries not loaded yet), not single messages, so both show the same number.
  // Open chats are already being read on /messages; elsewhere they count.
  const onMessagesPage = pathname === "/messages";
  const emailBadge = hideEmailClient ? 0 : Number(unSeenAllCount?.unseenEmailCount) || 0;
  const chatBadge = hideChats
    ? 0
    : countUnreadChats(
        hideTeams ? (activityMessages || []).filter((row) => !isTeamsChat(row)) : activityMessages,
        badgeChatsOf(unSeenAllCount),
        { countOpened: !onMessagesPage }
      );
  // Daily reports are shown on the cockpit only, so they don't count here.
  const messagesSidebarBadge = chatBadge + emailBadge;
  const roomsSidebarBadge =
    (Number(unSeenAllCount?.unseenExternalProject) || 0) +
    (Number(unSeenAllCount?.unseenInternalProject) || 0) +
    dailyBriefingBadge;
  const unseenArticleTotal = useSelector(
    (e) => (e.unSeenAllCount?.unseenArticleExternal || 0) + (e.unSeenAllCount?.unseenArticleInternal || 0)
  )
  const callIconRef = useRef(null);
  const [pulsePos, setPulsePos] = useState(null);

  useEffect(() => {
    if (callIconRef.current && runningCalls?.length > 0) {
      const updatePos = () => {
        const rect = callIconRef.current?.getBoundingClientRect();
        if (rect) {
          setPulsePos({ top: rect.top + rect.height / 2, left: rect.left + rect.width / 2 });
        }
      };
      updatePos();
      const interval = setInterval(updatePos, 1000);
      return () => clearInterval(interval);
    } else {
      setPulsePos(null);
    }
  }, [runningCalls]);

  // Sync local openSidebar state with Redux activeSideBar
  // This ensures the nav icons update when navigating from other components
  useEffect(() => {
    if (activeSideBar && activeSideBar !== openSidebar) {
      setOpenSideBar(activeSideBar);
    }
  }, [activeSideBar]);

  // Global, capture-phase handler for internal-article chat links.
  // Chat markdown links can be rendered through several paths (react-markdown
  // custom <a>, translated HTML, dangerouslySetInnerHTML). A single delegated
  // listener here — mounted inside the app Router so `history` drives the
  // visible <Switch> — guarantees the click leaves the chat and opens the feed.
  useEffect(() => {
    const handler = (e) => {
      try {
        const anchor = e.target && e.target.closest && e.target.closest("a");
        if (!anchor) return;
        const rawHref = anchor.getAttribute("href") || anchor.getAttribute("data-href") || "";
        const articleId = parseScrollToArticleId(rawHref) || parseScrollToArticleId(anchor.href || "");
        if (!articleId) return;
        console.log("[ArticleLink] caught click →", { rawHref, resolved: anchor.href, articleId });
        e.preventDefault();
        e.stopPropagation();
        navigateToInternalArticle(history, articleId);
      } catch (_) {
        /* ignore */
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, [history]);

  useEffect(() => {
    // Toggle visibility every 3 seconds
    const interval = setInterval(() => {
      setIsVisible((prev) => !prev);
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval
  }, []);

  // Asks first, then the shared cleanup (same as the personal settings).
  const logout = () => confirmAndLogout({ strings, dispatch, history });
  const { strings } = React.useContext(LanguageContext);

  const handleSidebarClick = (type) => {
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: type })
    dispatch({ type: SET_CHAT_FULLSCREEN, payload: false })
    dispatch({ type: SET_ACTIVE_PINNED_ROOM_ID, payload: null })
    props.updateRightTop("");
    // Leave the open chat/email in place. Latest messages stays mounted and
    // refreshes quietly when this tab is opened again.
    if (type !== 'LatestMessages') {
      dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
      props.setInActivity(false)
      props.updateGroups([])
    }
    if (openSidebar === type || !drawerOpen) {
      props.handleDrawer(!drawerOpen);
    } else if (openSidebar !== type) {
      props.handleDrawer(true);
    }
    setOpenSideBar(type);
  };

  const [{ isOver, canDrop }, pinDropRef] = useDrop({
    accept: ROOM_DND_TYPE,
    canDrop: (item) => {
      const project = item && item.project;
      return !!(project && project.id && project.isJoin && !project.isDone);
    },
    drop: (item) => {
      const project = item && item.project;
      if (!project || !project.id || !project.isJoin || project.isDone) return;
      const current = pinnedRoomsRef.current || [];
      if (current.some((r) => String(r.id) === String(project.id))) return;
      if (current.length >= PINNED_ROOMS_MAX) {
        $crud.notify({ type: "error", message: strings.pinned_rooms_max });
        return;
      }
      persistPinnedRooms(
        [
          ...current,
          {
            id: project.id,
            name: project.name,
            image: project.image || null,
            themeColor: project.themeColor || null,
            isInternal: !!project.isInternal,
            isJoin: true,
            isDone: false,
          },
        ],
        dispatch
      );
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const openPinnedRoom = (pin) => {
    const room = resolvePinnedRoom(pin, reduxProjects, internalProjectsAll);
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    dispatch({ type: TOGGLE_PROJECT, payload: true });
    dispatch({ type: TOGGLE_TODO_VIEW, payload: false });
    dispatch({ type: SET_CHAT_FULLSCREEN, payload: false });
    dispatch({ type: SET_ACTIVE_PINNED_ROOM_ID, payload: pin.id });
    props.updateOpenChats([]);
    props.updateOpenProjects([room]);
    props.updateProjectAction(true);
    props.updateRightTop("project1");
    props.handleDrawer(false);
    props.setInActivity(false);
    history.push("/projects");
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: "project1" });
    setOpenSideBar("project1");
  };

  const unpinRoom = (e, pin) => {
    e.preventDefault();
    e.stopPropagation();
    const next = (pinnedRoomsRef.current || []).filter(
      (r) => String(r.id) !== String(pin.id)
    );
    persistPinnedRooms(next, dispatch);
    if (activePinnedRoomId != null && String(activePinnedRoomId) === String(pin.id)) {
      dispatch({ type: SET_ACTIVE_PINNED_ROOM_ID, payload: null });
      props.updateOpenProjects([]);
    }
  };

  const roomsNavActive = pathname === "/projects" && !activePinnedRoomId;
  const onCockpit = cockpitEnabled && (pathname === "/" || pathname === "/cockpit");
  const onNews = pathname === "/articles" || (!cockpitEnabled && pathname === "/");

  const openRoomsList = (e) => {
    if (e) e.preventDefault();
    dispatch({ type: SET_ACTIVE_PINNED_ROOM_ID, payload: null });
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    dispatch({ type: TOGGLE_PROJECT, payload: false });
    dispatch({ type: TOGGLE_TODO_VIEW, payload: false });
    dispatch({ type: SET_CHAT_FULLSCREEN, payload: false });
    props.updateOpenProjects([]);
    props.updateOpenChats([]);
    props.updateProjectAction(true);
    props.updateRightTop("project1");
    props.handleDrawer(false);
    props.setInActivity(false);
    history.push("/projects");
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: "project1" });
    setOpenSideBar("project1");
  };

  const openCockpit = () => {
    dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
    props.updateGroups([])
    props.setInActivity(false)
    history.push("/");
    handleSidebarClick("cockpit")
  };

  const openNews = () => {
    dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
    props.updateGroups([])
    props.setInActivity(false)
    history.push(cockpitEnabled ? "/articles" : "/");
    handleSidebarClick("articles")
  };

  const openMessages = (view) => {
    dispatch({ type: TOGGLE_LATEST_MSG, payload: true })
    dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
    dispatch({ type: SET_ACTIVE_PINNED_ROOM_ID, payload: null })
    props.updateGroups([])
    props.updateRightTop("");
    // Navigate to LatestMessages (always push to ensure route sync).
    // `view`: "email" -> E-Mail section, "all" -> "Alle" tab, undefined -> keep current tab.
    const search = view === "email" ? "?view=email" : view === "all" ? "?view=all" : "";
    const state = view === "email" ? { openEmailTab: true } : view === "all" ? { openAllTab: true } : undefined;
    history.push({ pathname: "/messages", search, state });
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'LatestMessages' })
    props.setInActivity(true)
    if (!drawerOpen) {
      props.handleDrawer(true);
    }
    setOpenSideBar("LatestMessages");
  };

  const messagesViewFromRoute = (route) =>
    route.includes("view=email") ? "email" : route.includes("view=all") ? "all" : undefined;

  // Greyed-out add-on (e.g. Kjuup-Chats hidden): ask, persist the preference,
  // then open the add-on's regular target.
  const enableAddon = async (entry) => {
    try {
      await $crud.confirm({
        title: "",
        textContent: strings[entry.enableConfirmKey] || strings.addon_enable_confirm || `${entry.label} aktivieren?`,
        options: { ok: strings.addon_enable || "Aktivieren", cancel: strings.cancel },
      });
    } catch {
      return;
    }
    try {
      await saveWorkspacePreferences(dispatch, user, entry.enablePref);
    } catch (e) {
      console.error(e);
      $crud.notify({ type: "error", message: strings.something_went_wrong });
      return;
    }
    $crud.notify({ type: "success", message: strings[entry.enabledNoticeKey] || strings.addon_enabled || `${entry.label} aktiviert` });
    const target = resolveProductTarget(entry, { ...personaInfo, ...entry.enablePref });
    if (target.kind === "internal" && target.route && target.route.startsWith("/messages")) {
      openMessages(messagesViewFromRoute(target.route));
    }
  };

  const openProductEntry = (entry) => {
    // Booked package: Kjuup.io manages the subscription, Kjuup+ opens its booking on the company view.
    if (isProductSubscribed(entry, personaInfo)) {
      dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
      props.setInActivity(false)
      if (entry.id === "kjuup_io") {
        openKjuupIoSubscription(dispatch, history, { personaInfo, subscription: subscriptionState });
        return;
      }
      const billedCompanyId = subscriptionState?.companyBilling?.companyId;
      const companyParam = entry.id === "kjuup_plus" && billedCompanyId ? `&company=${billedCompanyId}` : "";
      history.push(`${entry.subscribedRoute}${companyParam}&focus=${Date.now()}`);
      handleSidebarClick("cockpit");
      return;
    }
    if (entry && entry.id === "kjuup_plus") {
      dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
      props.setInActivity(false)
      history.push({ pathname: "/", search: `?section=kjuup-plus&focus=${Date.now()}` });
      handleSidebarClick("cockpit");
      return;
    }
    // Kjuup.io offer on the cockpit: bookable, or locked until enabled in the Admin Panel.
    if (entry && entry.id === "kjuup_io") {
      dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
      props.setInActivity(false)
      history.push({ pathname: "/", search: `?section=kjuup-io&focus=${Date.now()}` });
      handleSidebarClick("cockpit");
      return;
    }
    const target = resolveProductTarget(entry, personaInfo);
    const disabled = typeof entry.disabledFor === "function" && entry.disabledFor(personaInfo);
    if (disabled && entry.enablePref) {
      enableAddon(entry);
      return;
    }
    if (disabled && entry.disabledRoute) {
      dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
      props.setInActivity(false)
      history.push(entry.disabledRoute);
      handleSidebarClick("profile");
      return;
    }
    if (target.kind === "external" && target.url) {
      try {
        window.open(target.url, "_blank", "noopener,noreferrer");
      } catch (_) {
        window.location.href = target.url;
      }
      return;
    }
    if (target.kind === "internal" && target.route) {
      if (target.route.startsWith("/messages")) {
        openMessages(messagesViewFromRoute(target.route));
        return;
      }
      if (target.route.startsWith("/?") || target.route === "/") {
        dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
        dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
        props.setInActivity(false)
        history.push(target.route);
        handleSidebarClick("cockpit");
        return;
      }
      dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
      dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
      props.setInActivity(false)
      history.push(target.route);
      handleSidebarClick("profile");
      return;
    }
    setTeaserProduct(entry);
  };

  // Share sheet → clipboard → mail draft (shared with the personal settings).
  const recommend = () => recommendKjuup(strings);

  // Chats hidden -> the entry becomes "E-Mail" and opens the email client.
  // Chats hidden AND no email client ("Nur Projekte + Berichte") -> no entry
  // at all (reports live on the cockpit).
  const messagesLabel = hideChats ? strings.nav_email || "E-Mail" : strings.nav_messages;
  const messagesIcon = hideChats ? "mail" : "business_messages";
  const showMessagesEntry = !(hideChats && hideEmailClient);
  const userName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();

  // Long German compounds have no space to wrap inside the narrow column.
  const NARROW_LABEL_LINES = {
    Profileinstellungen: ["Profil-", "einstellungen"],
    Weiterempfehlen: ["Weiter-", "empfehlen"],
  };

  const renderLabel = (text, active, sub) => {
    const lines = !isDeskTopResolution && NARROW_LABEL_LINES[text];
    return (
      <div className={`sidenav-label${active ? " sidenav-label-active" : ""}${lines ? " sidenav-label--twoline" : ""}`}>
        {lines ? <>{lines[0]}<br />{lines[1]}</> : text}
        {sub && isDeskTopResolution ? <span className="sidenav-sublabel">{sub}</span> : null}
      </div>
    );
  };

  return (
    <>
      {drawerOpen && isDeskTopResolution && (
        <>
          <ReactTooltip id="projecttooltip" place="right" effect="solid">
            {" "}
            {strings.project_list}{" "}
          </ReactTooltip>
          <ReactTooltip id="profiletooltip" place="right" effect="solid">
            {strings.profile}{" "}
          </ReactTooltip>
          <ReactTooltip id="logout" place="right" effect="solid">
            {" "}
            {strings.logout}{" "}
          </ReactTooltip>
        </>
      )}

      <nav
        className={`main_nav${isDeskTopResolution ? " main_nav--wide" : ""} sidenav-products`}
        id="navbar_div"
        onWheel={(e) => {
          const el = e.currentTarget;
          el.classList.add("is-scrolling");
          window.clearTimeout(el._navScrollTimer);
          el._navScrollTimer = window.setTimeout(() => el.classList.remove("is-scrolling"), 700);
        }}
        onScroll={(e) => {
          const el = e.currentTarget;
          el.classList.add("is-scrolling");
          window.clearTimeout(el._navScrollTimer);
          el._navScrollTimer = window.setTimeout(() => el.classList.remove("is-scrolling"), 700);
        }}
      >
        <ul className="side_nav middle_bar">
          {/* Static Kjuup brand — the main program, independent of booked packages.
              The icon is the same element in both sidebar modes (same size + position);
              the wide sidebar only appends the text part of the wordmark next to it. */}
          <li className="home_icon sidenav-brand">
            <span className="sidenav-brand-inner">
              <span className="sidenav-brand-mark-wrap">
                <img className="sidenav-brand-mark" src={kjuupIconSrc} alt="Kjuup" draggable={false} />
              </span>
              {isDeskTopResolution ? (
                <span className="sidenav-brand-wordmark-wrap" aria-hidden="true">
                  <img className="sidenav-brand-wordmark" src={KJUUP_WORDMARK_SRC} alt="" draggable={false} />
                </span>
              ) : null}
            </span>
          </li>
          {runningCalls?.length > 0 && (
            <li onClick={() => dispatch({ type: SHOW_LIST_ONGOING, payload: true })} className="side-nav__calls">
              <span className="side-nav__calls-trigger">
                <div ref={callIconRef} className="video-call-icon-wrapper sidebar-call-icon">
                  <MaterialIcon icon="videocam" size={20} weight={300} color="var(--kjuup-accent)" />
                </div>
                <div className="sidenav-label video-call-icon-label side-nav__calls-label">
                  {strings.nav_call}
                </div>
              </span>
            </li>
          )}

          {/* The cockpit start page: "Mein Cockpit" for every package. */}
          {cockpitEnabled ? (
            <li
              className={`sidenav-product sidenav-product--active${onCockpit ? " sidenav-item-active" : ""}`}
              onClick={openCockpit}
            >
              <span>
                <MaterialIcon icon="grid_view" {...ICON_PROPS} />
                {renderLabel(strings.nav_my_cockpit || "Mein Cockpit", onCockpit)}
              </span>
            </li>
          ) : null}

          <li
            className={`sidenav-item--nested${onNews ? " sidenav-item-active" : ""}`}
            onClick={openNews}
          >
            <span>
              <MaterialIcon icon="brand_awareness" {...ICON_PROPS} />
              {unseenArticleTotal > 0 && (
                <Badge pill>{unseenArticleTotal > 99 ? '99+' : unseenArticleTotal}</Badge>
              )}
              {renderLabel(cockpitEnabled ? (strings.nav_news || "News") : strings.nav_home, onNews)}
            </span>
          </li>

          {/* Working pages nested below the active product */}
          {showMessagesEntry ? (
            <li
              className={`sidenav-item--nested${pathname === "/messages" ? " sidenav-item-active" : ""}`}
              onClick={() => openMessages(hideChats ? "email" : hideEmailClient ? "all" : undefined)}
            >
              <span className="svg_icon home_svg">
                <MaterialIcon icon={messagesIcon} {...ICON_PROPS} />
                {messagesSidebarBadge > 0 && (
                  <Badge pill>{messagesSidebarBadge > 99 ? "99+" : messagesSidebarBadge}</Badge>
                )}
                {renderLabel(messagesLabel, pathname === "/messages")}
              </span>
            </li>
          ) : null}
          {/* No ToDo entry: tasks live inside projects and on the cockpit. */}
          {/* Rooms — drop target for pinning up to 10 rooms */}
          <li
            className={`sidenav-item--nested sidenav-rooms-cluster sidenav-rooms-cluster--dropzone ${pinnedRooms.length ? "sidenav-rooms-cluster--has-pins" : ""} ${
              (props.rightTop === "project1") ? "active_nav" : "diactive_nav"
            }`}
            data-tip
            data-for="projecttooltip"
          >
            <span className={`svg_icon home_svg sidenav-rooms-trigger${roomsNavActive ? " sidenav-item-active" : ""}`} onClick={openRoomsList}>
              <MaterialIcon icon="folder_open" {...ICON_PROPS} />
              {roomsSidebarBadge > 0 && (
                <Badge pill>{roomsSidebarBadge > 99 ? "99+" : roomsSidebarBadge}</Badge>
              )}
              <div className={`sidenav-label${roomsNavActive ? " sidenav-label-active" : ""}`}>
                {pinnedRooms.length > 0
                  ? (strings.nav_all_rooms || strings.nav_rooms)
                  : strings.nav_rooms}
              </div>
            </span>
            <div
              ref={pinDropRef}
              className={`sidenav-rooms-dropzone${isOver && canDrop ? " sidenav-rooms-dropzone--over" : ""}${pinnedRooms.length ? " sidenav-rooms-dropzone--filled" : ""}`}
            >
              {pinnedRooms.length < PINNED_ROOMS_MAX && (
                <div className="sidenav-rooms-dropzone-label">
                  {strings.pinned_rooms_drop}
                </div>
              )}
              {pinnedRooms.length > 0 && (
                <div className="sidenav-pinned-rooms-section">
                  {pinnedRooms.map((pin) => {
                    const live = findRoomInLists(pin.id, reduxProjects, internalProjectsAll) || pin;
                    const badge = roomUnreadCount(live, showDailyBriefingCounters);
                    const isActive = activePinnedRoomId != null && String(activePinnedRoomId) === String(pin.id);
                    return (
                      <div
                        key={pin.id}
                        className={`sidenav-pinned-room ${isActive ? "sidenav-pinned-room-active" : ""}`}
                        title={isDeskTopResolution ? pin.name : undefined}
                        onClick={() => openPinnedRoom(pin)}
                      >
                        <div className="sidenav-pinned-room-icon-wrap">
                          {pin.image ? (
                            <img
                              src={BASE_URL + pin.image}
                              alt={pin.name}
                              className="sidenav-pinned-room-avatar"
                            />
                          ) : (
                            <div
                              className="sidenav-pinned-room-avatar side-nav__pin-avatar"
                              style={{ '--side-nav-pin-color': pin.themeColor || "#737373" }}
                            >
                              {getAvatarInitials(pin.name)}
                            </div>
                          )}
                          {badge > 0 && (
                            <Badge className="sidenav-pinned-room-badge" pill>
                              {badge > 99 ? "99+" : badge}
                            </Badge>
                          )}
                        </div>
                        <div className={`sidenav-pinned-room-name${isActive ? " sidenav-pinned-room-name-active" : ""}`}>
                          {live.name || pin.name || ""}
                        </div>
                        <button
                          type="button"
                          className="sidenav-pinned-room-unpin"
                          title={isDeskTopResolution ? strings.pinned_room_unpin : undefined}
                          onClick={(e) => unpinRoom(e, pin)}
                        >
                          <MaterialIcon icon="close" size={12} color="currentColor" />
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </li>

          {cockpitEnabled && packageOptions.length > 0 ? (
            <>
              <li className="sidenav-sep" aria-hidden="true" />
              {packageOptions.map((entry) => {
                // Booked packages show as active (tinted row, check mark) instead of as an offer.
                const subscribed = isProductSubscribed(entry, personaInfo);
                const comingSoon = !subscribed && typeof entry.comingSoonFor === "function" && entry.comingSoonFor(personaInfo);
                const comingSoonLabel = strings.products_coming_soon || "Coming soon";
                const subtitleKey = subscribed
                  ? entry.subscribedSubtitleKeyFor(personaInfo)
                  : typeof entry.subtitleKeyFor === "function" ? entry.subtitleKeyFor(personaInfo) : entry.subtitleKey;
                return (
                  <li
                    key={entry.id}
                    className={`sidenav-product sidenav-product--external sidenav-product--${entry.id}${subscribed ? " sidenav-product--subscribed" : ""}${comingSoon ? " sidenav-product--soon" : ""}`}
                    onClick={comingSoon ? undefined : () => openProductEntry(entry)}
                    aria-disabled={comingSoon ? true : undefined}
                    title={comingSoon ? `${entry.label} · ${comingSoonLabel}` : !isDeskTopResolution ? entry.label : undefined}
                  >
                    <span>
                      {entry.tile ? (
                        <PackageTile pkg={entry.tile} size="sm" className="sidenav-product-tile" />
                      ) : entry.iconSrc ? (
                        <img className="sidenav-product-logo" src={entry.iconSrc} alt="" />
                      ) : (
                        <MaterialIcon icon={entry.icon} {...ICON_PROPS} />
                      )}
                      {renderLabel(
                        entry.label,
                        false,
                        comingSoon ? comingSoonLabel : subtitleKey ? strings[subtitleKey] || strings[entry.subtitleKey] : null
                      )}
                      {subscribed ? (
                        <MaterialIcon icon="check_circle" size={18} fill={1} weight={400} color="currentColor" className="sidenav-product-check" />
                      ) : null}
                    </span>
                  </li>
                );
              })}
            </>
          ) : null}

          {/* Footer: profile, recommend, logout */}
          <li
            className={`sidenav-account-start${pathname === "/profile-setting" ? " sidenav-item-active" : ""}`}
            onClick={() => {
            dispatch({ type: TOGGLE_TODO_VIEW, payload: false })
            dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
            handleSidebarClick("profile")
          }}>
            <NavLink
              to="/profile-setting"
              activeClassName={
                (openSidebar === "profile" || activeSideBar == 'profile') ? "active" : ""
              }
              data-tip
              data-for="profiletooltip"
            >
              {user?.avatar && (
                <img
                  className="sidenav-profile-avatar"
                  src={BASE_URL + user?.avatar}
                  alt=""
                />
              )}
              {!user?.avatar && (
                <img
                  className="sidenav-profile-avatar"
                  src={process.env.PUBLIC_URL + "assets/img/head.svg"}
                  alt=""
                />
              )}
              {renderLabel(isDeskTopResolution && userName ? userName : strings.nav_profile, pathname === "/profile-setting", isDeskTopResolution && userName ? strings.nav_profile : null)}
            </NavLink>
          </li>
          {cockpitEnabled ? (
            <li className="sidenav-recommend" onClick={recommend} title={!isDeskTopResolution ? (strings.nav_recommend || "Weiterempfehlen") : undefined}>
              <span>
                <MaterialIcon icon="share" {...ICON_PROPS} />
                {renderLabel(strings.nav_recommend || "Weiterempfehlen", false)}
              </span>
            </li>
          ) : null}
          <li
            className="sidenav-logout"
            onClick={(e) => {
              e.preventDefault();
              logout();
            }}
            data-tip
            data-for="logout"
          >
            <span className="svg_icon logout_icon">
              <MaterialIcon icon="logout" {...ICON_PROPS} />
              <div className="sidenav-label">{strings.nav_logout}</div>
            </span>
          </li>
        </ul>
      </nav>
      {pulsePos && ReactDOM.createPortal(
        <div className="side-nav__call-pulse" style={{ top: pulsePos.top, left: pulsePos.left }}>
          <div className="side-nav__call-pulse-inner">
            <span className="video-call-pulse-ring"></span>
            <span className="video-call-pulse-ring"></span>
            <span className="video-call-pulse-ring"></span>
          </div>
        </div>,
        document.body
      )}
      <ProductTeaserModal product={teaserProduct} onClose={() => setTeaserProduct(null)} />
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    drawerOpen,
    unSeenAllCount,
    inActivity,
    projects,
    openProjects,
    openBottomProjects,
    toggleWorkArea,
    rightTop,
    rightBottom,
    openChats,
    openBottomChats,
    groups,
    isOpenByOwner,
    groupChats
  } = state;
  return {
    unseenNewsCount: unSeenAllCount?.unseenNewsCount,
    drawerOpen: drawerOpen,
    inActivity: inActivity,
    groups: groups,
    projects: projects,
    openProjects: openProjects,
    openBottomProjects: openBottomProjects,
    workArea: toggleWorkArea,
    rightTop: rightTop,
    rightBottom: rightBottom,
    openChats: openChats,
    openBottomChats: openBottomChats,
    isOpenByOwner: isOpenByOwner,
    unSeenAllCount: unSeenAllCount,
    groupChats: groupChats
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    updateOpenChats: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
    updateNewsCount: (count) =>
      dispatch({ type: NEWS_BADGE_COUNT, unseenNewsCount: count }),
    handleDrawer: (open) => dispatch({ type: TOGGLE_DRAWER, open }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
    setInActivity: (status) => dispatch({ type: SET_IN_ACTIVITY, status: status }),
    updateRightTop: (value) => dispatch({ type: RIGHT_TOP, rightTop: value }),
    updateProjectAction: (value) =>
      dispatch({
        type: UPDATE_PROJECT_ACTION_FIRE,
        updateProjectActionFire: value,
      }),
    updateOpenProjects: (projects) =>
      dispatch({ type: OPEN_PROJECTS, openProjects: projects }),
    toggleChat: () => dispatch({ type: TOGGLE_CHAT }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SideNave));
